import { render } from "./ProductDetailList.vue?vue&type=template&id=a23e5b52&scoped=true"
import script from "./ProductDetailList.vue?vue&type=script&lang=js"
export * from "./ProductDetailList.vue?vue&type=script&lang=js"

import "./ProductDetailList.vue?vue&type=style&index=0&id=a23e5b52&scoped=true&lang=css"

import exportComponent from "C:\\projects\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Company\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a23e5b52"]])

export default __exports__